import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalStorage } from '../../hooks/useLocalStorage';

export const Language: React.FC = () => {
  const { i18n } = useTranslation();
  const [, setValue] = useLocalStorage('preferredLanguage');

  const handleClick = (lng: string) => {
    setValue(lng);
    i18n.changeLanguage(lng);
  };

  return (
    <CDropdown inNav className="c-header-nav-items mx-2">
      <CDropdownToggle className="c-header-nav-link" color="secondary" caret={true}>
        <span className="text-uppercase">{i18n.language}</span>
      </CDropdownToggle>
      <CDropdownMenu placement="bottom-end" className="m-0">
        {i18n.language !== 'en'
          ? <CDropdownItem onClick={() => handleClick('en')}>
              EN
          </CDropdownItem>
          : null}
        {i18n.language !== 'nl'
          ? <CDropdownItem onClick={() => handleClick('nl')}>
              NL
          </CDropdownItem>
          : null}
      </CDropdownMenu>
    </CDropdown>
  );
};
